import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('circular-progress-bar', {
  root: {
    variants: {
      size: ['tiny', 'small', 'medium', 'large'],
      skin: ['standard', 'premium', 'success'],
    },
    states: ['light', 'error', 'success'],
  },
  progressBar: {},
  arcsContainer: {},
  backArc: {},
  foreArc: {},
  statusIndicator: {},
  label: {},
  progressIndicator: {},
});
